import React from 'react'

import { DropdownOptionSelection, FieldProps } from '../../../../../../../@types/types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { ConstructionConditionOption } from '../../../../../../../@types/dropdown-types'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../../objectDetails/fields/common/PopoverContent'
import { useTranslation } from 'react-i18next'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

export type ConstructionConditionValidationResult = {
  constructionCondition?: string[]
}

type AdditionalConstructionConditionProps = {
  showLabelWithTooltip?: boolean
}
export type ConstructionConditionFieldProps = FieldProps<ConstructionConditionValidationResult> &
  AdditionalConstructionConditionProps

const ConstructionConditionField: React.FC<ConstructionConditionFieldProps> = ({
  insertionData,
  onChange,
  screenName,
  validationMessages,
  wrapperClassName = getDefaultClasses('left'),
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && (
        <LabelWithTooltip
          inputId='construction-condition'
          labelText={t('wizard.screen.construction.condition')}
          tooltipContent={<PopoverContent translationKey='wizard.screen.construction.condition.tooltip' />}
          showMandatory={false}
        />
      )}
      <DropdownSelect
        label={showLabelWithTooltip ? '' : 'wizard.screen.construction.condition'}
        id='construction-condition'
        name='constructionCondition'
        value={insertionData.constructionCondition}
        noInformation={ConstructionConditionOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.construction.conditionTypes',
          options: Object.keys(ConstructionConditionOption),
        }}
        errors={validationMessages?.constructionCondition ?? []}
        onChange={(value: DropdownOptionSelection) =>
          onChange({ screen: screenName, property: 'constructionCondition' }, value.value!)
        }
      />
    </div>
  )
}

export default ConstructionConditionField
